import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ManageTransactionSubtypeComponent } from 'src/app/AddThings/manage-transaction-subtype/manage-transaction-subtype.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { CustomerTransactionsComponent } from 'src/app/Customer/customer-transactions/customer-transactions.component';
import { ThumbnailsListComponent } from 'src/app/Images/thumbnails-list/thumbnails-list.component';
import { UploadImageComponent } from 'src/app/Images/upload-image/upload-image.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';
import { Profile } from 'src/model/profile.model';
import { TxSet } from 'src/model/set.model';
import { Transaction } from 'src/model/transaction.model';
import { TransactionSubType } from 'src/model/transactionSubType.model';
import { SetService } from 'src/services/set.service';
import { TransactionService } from 'src/services/transaction.service';
import { AddReceiptSetComponent } from '../add-receipt-set/add-receipt-set.component';
import { ReceiptAddExpenseAdminRemarkComponent } from '../receipt-add-expense-admin-remark/receipt-add-expense-admin-remark.component';

@Component({
    selector: 'app-receipt-details',
    templateUrl: './receipt-details.component.html',
    styleUrls: ['./receipt-details.component.scss'],
    standalone: false
})
export class ReceiptDetailsComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private router = inject(Router);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private setService = inject(SetService);
  private transactionService = inject(TransactionService);

  @Input() receipt: TxSet;
  @Input() receiptId: number;
  @Input() isModal = false;
  @Input() expenseSubtypeList: TransactionSubType[];
  @Input() dlSubtypeList: TransactionSubType[];

  @Output() passEntry = new EventEmitter<any>();
  checkerRemark = "";

  isEditing = false;
  editedRemark = "";

  transactionCustomerIsReady = false;
  transactionCustomer: Customer;

  subtypeList: Record<number, TransactionSubType> = {};

  adminView: boolean;

  isDirty = false;

  async ngOnInit(): Promise<void> {
    if (this.dlSubtypeList == undefined)
      this.dlSubtypeList = await this.transactionService.getTransactionSubTypes(this.enums.EXTRAS);

    if (this.expenseSubtypeList == undefined)
      this.expenseSubtypeList = await this.transactionService.getTransactionSubTypes(this.enums.EXPENSE)

    this.adminView = this.sharedService.isRoles([this.enums.ADMIN, this.enums.BOSS, this.enums.FINANCE, this.enums.EXPENSE_ADMIN]);
    this.subtypeList = Array.from(new Set([...this.dlSubtypeList, ...this.expenseSubtypeList])).reduce((acc, o) => {
      acc[o.ID] = o;
      return acc;
    }, {} as Record<number, TransactionSubType>);
    if (this.receiptId != undefined)
      this.getSetDetails();
  }

  async getSetDetails() {
    this.receipt = await this.setService.getTxSetDetails(this.receiptId);
  }

  editRemark(remark: string) {
    this.editedRemark = remark;
    this.isEditing = true;
  }

  reset() {
    this.activeModal.close();
    if (this.isDirty == true)
      window.location.reload();
  }

  loadTransactionCustomer(transactionId: number) {
    this.transactionCustomerIsReady = false;
    const xhttp = this.restApi.getRequest(this.constructApi.getTypedTransaction("loans", transactionId))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        this.transactionCustomerIsReady = true;
        const json = JSON.parse((xhttp.responseText));

        this.transactionCustomer = new Customer(json.customerId, json.customerName, undefined, undefined, undefined, json.icNumber, undefined, undefined, undefined, undefined,
          undefined, undefined, undefined, undefined, undefined, json.companyId, undefined, undefined, undefined, [new Profile(json.profileId, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)])
      }
    };
  }

  viewCustomerTransaction(profileId: number, companyId: number, transaction: Transaction) {
    const modalRef = this.sharedService.openModal(CustomerTransactionsComponent, "largeModal");
    modalRef.componentInstance.profileId = profileId;
    modalRef.componentInstance.companyId = companyId;
    modalRef.componentInstance.startDate = new Date(transaction.Date);
    modalRef.componentInstance.endDate = new Date(transaction.Date);
  }

  goToCustomer(customerId: number) {
    this.activeModal.close();
    this.router.navigate(['/manageCustomer', customerId]);
  }

  calculateTransactionTotal(transactionList: Transaction[]) {
    return transactionList.reduce((acc, o) => acc + o.Amount, 0);
  }

  openAddTransactionToSetModal() {
    const modalRef = this.sharedService.openModal(AddReceiptSetComponent, "largeModal");
    modalRef.componentInstance.setId = this.receipt.ID;
  }

  confirmDeleteTransaction(transaction?: Transaction) {
    let transInfo = 'ALL transactions';
    if (transaction !== undefined) transInfo = `this transaction: '${transaction.Remark} - RM${transaction.Amount}'`;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = `Are you sure you want to REMOVE ${transInfo} from receipt?`;
    return modalRef.result;
  }

  deleteTransaction(transaction: Transaction) {
    if (transaction !== undefined) {
      this.confirmDeleteTransaction(transaction).then((confirm) => {
        if (confirm) {
          this.deleteTransactionsFromSet([transaction.ID])
        }
      });
    }
  }

  deleteAllTransactions() {
    this.confirmDeleteTransaction().then((confirm) => {
      if (confirm) {
        const ids = this.receipt.TransactionIdList ?? this.receipt.TransactionList.map(t => t.ID);
        this.deleteTransactionsFromSet(ids);
      }
    });
  }

  async deleteTransactionsFromSet(transactionIds: number[]) {
    const res = await this.setService.deleteCompanySetTransactions(this.receipt.CompanyId, this.receipt.ID, transactionIds);
    if (res) window.location.reload();
  }

  async submitSet() {
    const res = await this.setService.putSubmitSet(this.receipt.CompanyId, this.receipt.ID);
    if (res) window.location.reload();
  }

  async confirmBeforeValidation(valid: boolean): Promise<boolean> {
    const action = valid ? 'VALIDATE' : 'INVALIDATE';
    if (!valid && (this.checkerRemark == "" || this.checkerRemark == undefined)) {
      this.sharedService.openAlert("Please fill in remark to explain invalidate reason", ALERT_TYPE.DANGER);
      return false;
    }
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = `Are you sure you want to ${action} this receipt?`;
    return modalRef.result;
  }

  async setValidation(valid: boolean) {
    const confirm = await this.confirmBeforeValidation(valid);
    if (confirm) {
      const res = await this.setService.putSetValidation(this.receipt.CompanyId, this.receipt.ID, valid, this.checkerRemark);
      if (res) {
        this.receipt.Valid = valid;
        this.passEntry.emit(valid);
      }
    }
  }

  async updateRemark() {
    const res = await this.setService.patchEditSet(this.receipt.ID, this.editedRemark);
    if (this.isModal && res) this.passEntry.emit();
  }

  async viewSetFiles() {
    const files = await this.setService.getSetFiles(this.receipt.ID);
    const modalRef = this.sharedService.openModal(ThumbnailsListComponent, 'largeModal');
    const i = modalRef.componentInstance as ThumbnailsListComponent;
    i.fileArr.set(files);
    if (this.sharedService.isAdmin())
      i.showDelete = false;
    else if (this.sharedService.isBranchManager())
      i.showDelete = this.receipt.Valid === false;
  }

  addEvidenceForSet() {
    const modalRef = this.sharedService.openModal(UploadImageComponent);
    modalRef.componentInstance.isSetDocument = true;
    modalRef.componentInstance.setId = this.receipt.ID;
    this.isDirty = true;
  }

  async confirmRemoveBookmark() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to REMOVE BOOKMARK for this receipt?";
    return modalRef.result;
  }

  async removeBookmark() {
    this.confirmRemoveBookmark().then(async (confirm) => {
      if (confirm) {
        const s = Object.assign(new TxSet(), this.receipt);
        s.Saved = false;
        this.receipt = await this.setService.putSetRemark(s);
        if (this.isModal) this.passEntry.emit(this.receipt);
      }
    });
  }

  checkOpenBookmark() {
    if (this.receipt.Saved !== true) {
      const modalRef = this.sharedService.openModal(ReceiptAddExpenseAdminRemarkComponent);
      modalRef.componentInstance.set = this.receipt;
      modalRef.componentInstance.passEntry.subscribe((entry) => {
        if (entry) {
          this.receipt = entry;
          if (this.isModal) this.passEntry.emit(entry);
        }
      });
    } else {
      this.removeBookmark();
    }
  }

  openEditSetRemark() {
    const modalRef = this.sharedService.openModal(ReceiptAddExpenseAdminRemarkComponent);
    modalRef.componentInstance.set = this.receipt;
    modalRef.componentInstance.editMode = true;
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      this.receipt = entry;
      if (this.isModal) this.passEntry.emit(entry);
    });
  }

  removeSetTag(index: number) {
    this.confirmRemoveTag(this.receipt.Tags[index]).then(async (confirm) => {
      if (confirm) {
        this.receipt.Tags.splice(index, 1);
        this.receipt = await this.setService.putSetRemark(this.receipt);
        if (this.isModal) this.passEntry.emit(this.receipt);
      }
    });
  }

  confirmRemoveTag(tag: string) {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to Tag '" + tag + "' for this receipt?";
    return modalRef.result;
  }

  openManageSubtypeModal(transaction: Transaction) {
    const modalRef = this.sharedService.openModal(ManageTransactionSubtypeComponent);
    modalRef.componentInstance.currentSubtype = transaction.Subtype;
    modalRef.componentInstance.transaction = transaction;
    modalRef.componentInstance.subtypeList = (transaction.Type === this.enums.EXPENSE ? this.expenseSubtypeList : this.dlSubtypeList).filter(s => s.Enabled && s.Assignable);
    modalRef.componentInstance.passEntry.subscribe((entry) => {
      if (entry) {
        transaction.Subtype = entry.Subtype;
      }
    });
  }
}
